<template>
  <div class="Dialog">
    <div class="Dialog-wrapper">
      <div class="slot">
        <slot />
      </div>
      <div class="close" @click="handleClose"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>
<style lang="scss" scoped>
.Dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-image: url("~@/assets/reservation/message_popup.png");
  z-index: 9;
  width: 30vw;
  aspect-ratio: 747/335;
  background-size: contain;
  background-repeat: no-repeat;
  @media screen and (max-width: 900px) {
    width: 80vw;
  }
  &-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    .slot {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40%;
    }
    .close {
      position: absolute;
      right: 1.5%;
      top: 2%;
      z-index: 10;
      cursor: pointer;

      width: 6.5%;
      height: 16%;
      border-radius: 50%;
    }
  }
}
</style>
